import { TopDownItemId } from './config';
import type { FocusPlacement } from './positions';

export type FocusMode = 'generic' | 'self';

export interface ItemScatterConfig {
    mode: FocusMode;
    contentId?: string;
    /**
     * Placement overrides to use when some item is focused and this item
     * is participating in the scattered layout (i.e. not the primary focus).
     * Typically only some properties are overridden.
     */
    scatterPlacement?: FocusPlacement;
}

/**
 * Configuration map for each item's scatter/focus behavior
 * (mode/content mapping is also used by the focus controller).
 *
 * NOTE: values here were originally defined in `focusConfig.ts` and have been
 * moved verbatim; only the property name changed from `focusPlacement` to
 * `scatterPlacement` to better reflect their role.
 */
export const scatterConfig: Map<TopDownItemId, ItemScatterConfig> = new Map([
    [TopDownItemId.Schedule, {
        mode: 'self',
        scatterPlacement: {
            // top: '10%',
            // left: '10%',
            // width: '95%',
            // rotate: '-4deg', // Inverted from base rotation
        }
    }],
    [TopDownItemId.Shoes, {
        mode: 'generic',
        contentId: 'dresscode',
        scatterPlacement: {
            // top: '0%',
            // left: '10%',
            // // width: '120%',
            // rotate: '-4deg', // Inverted from base rotation
        }
    }],
    [TopDownItemId.Bowtie, {
        mode: 'generic',
        contentId: 'dresscode',
    }],
    [TopDownItemId.Matchbox, {
        mode: 'generic',
        contentId: 'faq',
    }],
    [TopDownItemId.ChromeTV, {
        mode: 'generic',
        contentId: 'tv-gallery',
    }],
    [TopDownItemId.Envelope, {
        mode: 'generic',
        contentId: 'rsvp',
    }],
    [TopDownItemId.Hotels, {
        mode: 'generic',
        contentId: 'hotel-schedule',
    }],
]);


